import { ContactUsLink, ErrorSection } from '@/src/components';
import { BANNER_CTA_CLICKED } from '@/src/constants/analytics';
import { OVO_QUOTE_AND_SWITCH } from '@/src/constants/endpoints';
import { MOVE_OUT_IN_PROGRESS_ERROR } from '@/src/constants/error-section-ids';
import { SkeletonCard } from '@/src/pages/Home/components/SkeletonCard';
import {
  Card,
  Heading3,
  Heading4,
  P,
  PrimaryCTALink,
  Strong,
} from '@ovotech/nebula';
import React from 'react';
import { ActionCentreBanner } from '@/src/components/ActionCentre/Banners/banners';
import { Banner } from '@/src/components/ActionCentre/Banners/Banner';
import { CollapsibleBlock } from '@/src/components/ActionCentre/Banners/CollapsibleBlock';
import { useMoveOutData } from '@/src/components/ActionCentre/Banners/MoveOut/useMoveOutData';

export const MoveOutInProgress: ActionCentreBanner = () => {
  const { isLoading, isError, address, moveOutDate } = useMoveOutData();

  if (isLoading) {
    return <SkeletonCard testId="loader" />;
  }

  if (isError) {
    return (
      <Card>
        <ErrorSection alertLevel="error" id={MOVE_OUT_IN_PROGRESS_ERROR} />
      </Card>
    );
  }

  return (
    <Banner icon="loss">
      <Heading3 as="h2">Goodbye from us!</Heading3>
      <P>
        Thanks for letting us know you’re moving out of{' '}
        <Strong>{address ? address : 'unknown address'}</Strong>
        {moveOutDate && (
          <>
            {' '}
            on the <Strong>{moveOutDate}</Strong>
          </>
        )}
        . We'll end your contract on this date, create a final statement and
        refund any money left on your account. You've been an awesome OVO
        member!
      </P>
      <P>
        Something not right? Moving out date changed?{' '}
        <ContactUsLink>Please let us know</ContactUsLink>
      </P>

      <CollapsibleBlock bannerId="moveOutInProgress">
        <Heading4 as="h3">Want us to power your new home?</Heading4>
        <PrimaryCTALink
          data-event-name={BANNER_CTA_CLICKED}
          data-event-props={JSON.stringify({
            bannerId: 'moveOutInProgress',
            ctaName: 'Get a quote',
          })}
          href={OVO_QUOTE_AND_SWITCH}
          opensInNewWindow
        >
          Get a quote
        </PrimaryCTALink>
      </CollapsibleBlock>
    </Banner>
  );
};
